module.exports = __webpack_public_path__ + "static/media/edit.f385c100.svg";